import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

import { CacheKeys } from '../lib/cache'
import { toCamelCase } from '../lib/typeHelper'

export interface SendBorLinkResponse {
  link: string
  sentTo: string
}

export async function sendBorLink(
  orgId: string,
  notifyCustomer: boolean = true
): Promise<SendBorLinkResponse> {
  const { data } = await axios.post(`/api/v1/insure/organisations/${orgId}/send-bor-link/`, {
    notify_customer: notifyCustomer,
  })
  return toCamelCase(data) as SendBorLinkResponse
}

export async function sendRegularBorLink(
  orgId: string,
  notifyCustomer: boolean = true
): Promise<SendBorLinkResponse> {
  const { data } = await axios.post(`/api/v1/insure/organisations/${orgId}/send-regular-bor-link/`, {
    notify_customer: notifyCustomer,
  })
  return toCamelCase(data) as SendBorLinkResponse
}

export async function sendRocklakePaymentAuthorizationLink(
  orgId: string,
  notifyCustomer: boolean = true
): Promise<SendBorLinkResponse> {
  const { data } = await axios.post(
    `/api/v1/insure/organisations/${orgId}/send-rocklake-payment-authorization-link/`,
    { notify_customer: notifyCustomer }
  )
  return toCamelCase(data) as SendBorLinkResponse
}

export async function sendRocklakeCreditCardAuthorizationLink(
  orgId: string,
  notifyCustomer: boolean = true
): Promise<SendBorLinkResponse> {
  const { data } = await axios.post(
    `/api/v1/insure/organisations/${orgId}/send-rocklake-credit-card-authorization-link/`,
    { notify_customer: notifyCustomer }
  )
  return toCamelCase(data) as SendBorLinkResponse
}

export interface BorSignUrl {
  signUrl?: string
  clientId?: string | null
  signed: boolean
}

function getBorSignUrl(appId: string): Promise<BorSignUrl> {
  return axios
    .get(`/api/v1/insure/applications/${appId}/bor-envelope/sign-url/`)
    .then((response) => toCamelCase(response.data) as BorSignUrl)
}

export function useBorSignUrl(appId: string | undefined) {
  return useQuery({
    queryKey: [CacheKeys.BOR_SIGN_URL, appId],
    queryFn: () => getBorSignUrl(appId!),
    enabled: !!appId,
    retry: false,
  })
}
